"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "fluid", "as", "children", "ariaLabel"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = "/**\n * Creates an inset border around the element that does not alter the position of its content.\n * This is achieved by overriding whatever border the element currently has and creating a\n * pseudo class with the new desired border.\n * \n * @param $border-width: The width of the new border.\n * @param $border-style: The style of the new border.\n * @param $border-color: The color of the new border.\n */\n.Container {\n  max-width: 72rem;\n  padding: 0 1rem;\n  margin: 0 auto;\n  box-sizing: content-box;\n}\n.Container.fluid {\n  max-width: 100%;\n}\n@media (min-width: 48.0625rem) {\n  .Container {\n    padding: 0 3rem;\n  }\n}";
  var fileName = "Container_Container";
  var element = document.querySelector("style[data-sass-component='Container_Container']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var Container = function Container(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$fluid = _ref.fluid,
    fluid = _ref$fluid === void 0 ? false : _ref$fluid,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    children = _ref.children,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? 'container' : _ref$ariaLabel,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var As = as;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(As, _objectSpread(_objectSpread({
    "aria-label": "".concat(ariaLabel || 'container', " "),
    className: "Container ".concat(className, " ").concat(fluid ? 'fluid' : '')
  }, rest), {}, {
    children: children
  }));
};
var _default = Container;
exports["default"] = _default;